// src/utils/logger.js
import { SendLogs } from '../utils/bridge';
export const sendLogToServer = async (log) => {
  try {
    await fetch(SendLogs, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(log),
    });
  } catch (e) {
    console.error("No se pudo enviar log al servidor:", e);
  }
};

export const logMessage = (level, message, info = null, context = {}) => {
  const entry = {
    level,
    message: message?.toString() || message,
    info,
    context,
    date: new Date().toISOString(),
    userAgent: navigator.userAgent,
  };

  // Guardar en LocalStorage
  const logs = JSON.parse(localStorage.getItem("appLogs")) || [];
  logs.push(entry);
  localStorage.setItem("appLogs", JSON.stringify(logs));

  // Enviar al servidor
  sendLogToServer(entry);

  // Consola
  if (level === "error") console.error(message, info);
  else if (level === "warn") console.warn(message, info);
  else console.log(message, info);
};
